<template>
  <div class="flex flex-col justify-between min-h-screen">
    <intro
      v-if="useIntro"
      class="fixed z-[1000] inset-0 w-full h-full"
      @close="handleIntroClose"
    />

    <div id="smooth-wrapper">
      <div id="smooth-content">
        <div
          class="flex flex-col justify-between min-h-screen bg-skin-base text-skin-base"
        >
          <div class="flex flex-col justify-start items-stretch">
            <app-header
              v-if="$route.name !== 'locale'"
              class="relative top-0 left-0 z-[2]"
            />
            <main class="overflow-hidden relative top-0 left-0 w-full">
              <NuxtPage class="overflow-hidden w-full max-w-full" />
            </main>
          </div>
          <app-footer v-if="$route.name !== 'locale'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRootStore } from "@/stores/root";
const rootStore = useRootStore();
const { isDesktop } = useDevice();
const {
  $t,
  $initScrollSmoother,
  $destroyScrollSmoother,
  $resumeScrollSmoother,
} = useNuxtApp();

const route = useRoute();
const useIntro = ref(
  route.name === "locale-id" ||
    route.name === "locale-demo-components" ||
    route.name === "locale-camaleonda"
);

const headers = useRequestHeaders(["accept"]);

if (process.server) {
  rootStore.setAvif(/image\/avif/.test(headers["accept"]));
}

function handleIntroClose() {
  useIntro.value = false;
  $resumeScrollSmoother(false);
}

// INIT APP
rootStore.setCDNFolder(rootStore.host);

const formKitConfig = inject(Symbol.for("FormKitConfig"));
formKitConfig.locale = route.params.locale?.split("-")[0] || "en";

const { setAnalytics } = useAnalytics();
setAnalytics();

if (isDesktop) {
  watch(
    route,
    () => {
      $destroyScrollSmoother();
      if (
        route.name === "locale-id" ||
        route.name === "locale-demo-components" ||
        route.name === "locale-camaleonda"
      ) {
        $initScrollSmoother(false);
      }
    },
    { deep: true }
  );
}

onMounted(async () => {
  if (isDesktop && useIntro.value) {
    $initScrollSmoother(useIntro.value);
  }
});

// HeadlessUI: to avoid hydration issues due to ID mismatches
provideHeadlessUseId(() => useId());
</script>
